(function(){
    // console.log('产品详情 bulndle:init 事件监听器已加载');
    // console.log('productJson:', productJson);
    const svgIcon = `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.38452 5.96143H16.692L15.8971 16.692H3.17938L2.38452 5.96143Z" stroke="#171717" stroke-linejoin="round"/>
            <path d="M6.35889 7.55111V2.38452H12.7178V7.55111" stroke="#171717" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.75 11.3268H11.3269" stroke="#171717" stroke-linecap="round"/>
            <path d="M9.53833 9.53833L9.53833 13.1152" stroke="#171717" stroke-linecap="round"/>
            </svg>
            `;
        var oneTimer = null;
  
      document.addEventListener('bundle:init', function (e) {
       
         //获取 .Upsell-title 元素，显示该元素，.Upsell-title 就一个
                //    document.querySelector('.Upsell-title')? document.querySelector('.Upsell-title').style.display = 'block': '';
        if(oneTimer) clearTimeout(oneTimer);
          oneTimer = setTimeout(()=>{
                try{
                    //获取 primary-title 元素，更改其文本内容 为 Upsell 
                    // document.querySelector('.rebuy-widget.widget-type-dynamic-bundle .primary-title').textContent = 'Upsell';
                    
                    console.log('产品详情 bulndle:init 事件触发，Rebuy widget 已初始化');
                    document.querySelectorAll('.rebuy-widget.widget-type-dynamic-bundle .rebuy-bundle__actions').forEach(actionBox => {
                        // 1️⃣ 插入 SVG 到按钮
                        const buttons = actionBox.querySelectorAll('.rebuy-bundle__actions-buttons');
                        buttons.forEach(button => {
                        button.insertAdjacentHTML('afterbegin', svgIcon);
                        });

                        // 2️⃣ 读取价格
                        const saleSpan = actionBox.querySelector('.rebuy-bundle__actions-price span.sale span:last-child');
                        const compareSpan = actionBox.querySelector('.rebuy-bundle__actions-price span.compare-at span:last-child');

                        if (saleSpan && compareSpan) {
                        const saleRaw = saleSpan.textContent.trim();
                        const compareRaw = compareSpan.textContent.trim();

                        // 提取货币符号（第一个非数字字符）
                        const currencySymbolMatch = compareRaw.match(/^[^\d]+/);
                        const currency = currencySymbolMatch ? currencySymbolMatch[0] : '';

                        // 提取纯数字
                        const sale = parseFloat(saleRaw.replace(/[^0-9.]/g, ''));
                        const compare = parseFloat(compareRaw.replace(/[^0-9.]/g, ''));

                        if (!isNaN(sale) && !isNaN(compare) && compare > sale) {
                            const discount = (compare - sale).toFixed(2);

                            // 创建按钮
                            const saveBtn = document.createElement('div');
                            saveBtn.textContent = `SAVE -${currency}${discount}`;
                            saveBtn.classList.add('save_price_button')

                            console.log('创建 SAVE 按钮:', saveBtn);
                            console.log('插入到:', actionBox.querySelector('.rebuy-bundle__actions-price'));
                            // 插入当前 actionBox 下的 class  rebuy-bundle__actions-price 里
                            actionBox.querySelector('.rebuy-bundle__actions-price').appendChild(saveBtn);
                        }
                        }
                    });

                    ////////
                  //   console.log('获取event对象:', e.detail);
                        console.log(window.Rebuy.widgets);
                        var widgets = window.Rebuy.widgets;
                        for(var i=0;i<widgets.length;i++){
                            var widget = widgets[i];
                         //   console.log('获取 widget 对象:', widget);
                            var product_variants = widget.data.products[0].variants;
                            const product_media = widget.data.products[0].images;
                          

                          
                            //获取父级元素根据id ,rebuy-widget-255672
                            const parentElement = document.getElementById(`rebuy-widget-${widget.id}`);

                            const variantImageMap = product_variants.map((variant, index) => {
                            const mediaItem = product_media.filter(m => m.id === variant.image_id);
                            // console.log('variant:', variant);
                            // console.log('对应的 mediaItem:', mediaItem);
                            if(mediaItem.length > 0){
                                mediaItem.forEach(mi => {
                                    //在 parentElement 下查找 rebuy-product-options__button-swatch 的 label 元素，设置其 innerHTML 为 img 标签，src 为 mi 的 src，宽高为 40px
                                     parentElement.querySelectorAll('.rebuy-product-options__button-swatch label')[index].innerHTML = `<img src="${mi.src+ '&width=20'}" alt="${variant.title}" style="width:100%;height:100%;object-fit:cover;" />`;
                                     parentElement.querySelectorAll('.rebuy-product-options__button-swatch label')[index].style.display = 'block';
                                    // parentElement.querySelectorAll('.rebuy-product-options__button-swatch label')[index].style.backgroundImage = `url(${mi.preview_image.src})`;
                                });
                        

                            }

                             //在 parentElement 下查找 rebuy-product-options__button-swatch 的 label 元素，设置其 innerHTML 为 img 标签，src 为 mediaItem 的 src，宽高为 40px
                             //   parentElement.querySelectorAll('.rebuy-product-options__button-swatch label')[index].innerHTML = `<img src="${mediaItem ? mediaItem.src+ '&width=40' : ''}" alt="${variant.title}" style="width:100%;height:100%;object-fit:cover;" />`;
                              //   parentElement.querySelectorAll('.rebuy-product-options__button-swatch label')[index].style.display = 'block';
                                // parentElement.querySelectorAll('.rebuy-product-options__button-swatch label')[index].style.backgroundImage = `url(${mediaItem ? mediaItem.preview_image.src : ''})`;
                                // return {
                                //     variantId: variant.id,
                                //     title: variant.title,
                                //     image: mediaItem ? mediaItem.preview_image.src : null
                                // };
                                // 根据 下查找  rebuy-product-options__button-swatch
                            });

                            // 输出映射结果
                            // console.log(variantImageMap);
                        }
                   

                }catch{
                
                }
            },2000);
      
       
        //获取 product-info__block-item 下的 元素属性 data-rebuy-id
        // console.log('bundle:init 事件触发，Rebuy widget 已初始化');
        // const rebuyElements = document.querySelectorAll('.product-info__block-item div[data-rebuy-id]');
        // rebuyElements.forEach(element => {
        //   const rebuyId = element.getAttribute('data-rebuy-id');
        //   console.log('找到 Rebuy 元素，ID:', rebuyId);
        //     //根据 rebuyId 获取对应的产品信息
        //     //假设有一个函数 getProductInfoByRebuyId 可以根据 rebuyId 获取产品信息
        //     // const productInfo = getProductInfoByRebuyId(rebuyId);
        //     // console.log('对应的产品信息:', productInfo);
        //        var widget = new Rebuy.Widget({
        //             id: rebuyId,
        //             shopifyProductIds: [productJson.id]
        //         });
        //         widget.init();
        //         console.log('产品详情 bulndle:Rebuy widget 已初始化');
        //         console.log('Rebuy widget 对象:', widget);
        // });

        
        // console.log('产品详情 bulndle:init 事件触发，Rebuy widget 已初始化');
                        //在 rebuy-bundle__actions 元素内的 rebuy-bundle__actions-buttons 按钮前插入 SVG 图标
                       
                        // //获取 widget 对象
                        // var widget = window.Rebuy.widgets[0];
                        // console.log(widget.data.products);

                        //根据 e.detail.id 获取对应的产品选项容器
                        // if(e.detail.id){
                        //     $(`#rebuy-widget-${e.detail.id} .rebuy-bundle__items .rebuy-product-options .rebuy-size-swatches`)
                        // }
                       
    })
  //监听 bundle:cart:add 事件
        document.addEventListener('bundle:cart:add', function (e) {
           
            //更新购物车图标或执行其他操作
            //执行 cart:refresh 事件以刷新购物车
            document.dispatchEvent(new Event('cart:refresh'));
            //获取 aria-controls="cart-drawer" 的元素，执行点击事件以打开购物车抽屉
            const cartDrawerToggle = document.querySelector('a[aria-controls="cart-drawer"]');
            if (cartDrawerToggle) {
                cartDrawerToggle.click();
            }
        });


})();